// extracted by mini-css-extract-plugin
export default {"link":"Link__link--saE"};